import { useTranslation } from 'react-i18next'

import { CrownIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SmartTrackingRequestedCard = () => {
  const { t } = useTranslation()

  return (
    <Styles.Card>
      <Styles.Icon>
        <CrownIcon size={24} />
      </Styles.Icon>
      <Styles.Content>
        <Text type="titleS">{t('Smart Tracking solicitado')}</Text>
        <Text type="bodyXSRegular">
          {t('Nuestro equipo se pondrá en contacto contigo en breve para configurarlo.')}
        </Text>
      </Styles.Content>
    </Styles.Card>
  )
}

export default SmartTrackingRequestedCard
